import styled from "styled-components";

export const Container = styled.div`
  margin-left: 100px;
  margin-right: 100px;
  margin-top: 100px;
  display: flex;
  flex-flow: wrap;

  @media only screen and (max-width: 1010px) {
    margin-top: 60px;
    margin-left: 0px;
    margin-right: 0px;
  }
`;

export const TitleCardContainer = styled.div`
  width: 100%;
  padding-bottom: 50px;
  ${({ pleft }) => pleft && `padding-left: ${pleft}px`};

  @media only screen and (max-width: 560px) {
    width: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const SummaryCardContainer = styled.div`
  width: 50%;
  padding-bottom: 50px;
  ${({ pleft }) => pleft && `padding-left: ${pleft}px`};

  @media only screen and (max-width: 560px) {
    width: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-left: 0px;
  }
`;

export const TitleWrap = styled.div`
  position: relative;
  width: fit-content;
  padding-bottom: 16px;
`;

export const BgColorDiv = styled.div`
  height: 30px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.lightGray2};

  @media only screen and (max-width: 768px) {
    height: 25px;
    margin-bottom: 12px;
  }
  @media only screen and (max-width: 560px) {
    height: 20px;
    margin-bottom: 18px;
  }
`;

export const TitleText = styled.div`
  font-family: "Lora Medium";
  font-size: 40px;
  color: ${({ theme }) => theme.colors.blackGreen};
  margin-top: -54px;
  padding-left: 6px;
  padding-right: 12px;

  @media only screen and (max-width: 768px) {
    font-size: 30px;
  }
  @media only screen and (max-width: 560px) {
    font-size: 30px;
  }
`;

export const SubTitleText = styled.div`
  font-family: "Montserrat";
  font-size: 19px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.prune};
  padding-bottom: 8px;

  @media only screen and (max-width: 790px) {
    font-size: 15px;
  }

  @media only screen and (max-width: 560px) {
    font-size: 17px;
    letter-spacing: 2.04px;
  }
`;

export const DescriptionText = styled.div`
  font-family: "Helvetica";
  font-size: 15px;
  color: ${({ theme }) => theme.colors.black};
  letter-spacing: 1px;

  @media only screen and (max-width: 790px) {
    font-size: 14px;
  }

  @media only screen and (max-width: 560px) {
    font-size: 15px;
    letter-spacing: 0.9px;
  }
`;

export const ResponsiveTitleWrapMD = styled.div`
  width: 50%;
  display: block;
  @media only screen and (max-width: 1320px) {
    display: none;
  }
  @media only screen and (max-width: 560px) {
    display: block;
    width: 100%;
  }
  @media only screen and (max-width: 392px) {
    display: none;
  }
`;

export const ResponsiveTitleWrapSM = styled.div`
  width: 50%;
  display: none;
  @media only screen and (max-width: 1320px) {
    display: block;
  }
  @media only screen and (max-width: 560px) {
    display: none;
  }
  @media only screen and (max-width: 392px) {
    display: block;
    width: 100%;
  }
`;
